
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/next-generation",
      function () {
        return require("private-next-pages/stories/next-generation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/next-generation"])
      });
    }
  